import { render, staticRenderFns } from "./SelectionTags.vue?vue&type=template&id=6d21849a&scoped=true&"
import script from "./SelectionTags.vue?vue&type=script&lang=js&"
export * from "./SelectionTags.vue?vue&type=script&lang=js&"
import style0 from "./SelectionTags.vue?vue&type=style&index=0&id=6d21849a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21849a",
  null
  
)

export default component.exports